import { getLink } from '../../../utils/utils';

import author from './author';

const content = {
  esp: (
    `
    <p class="mb-3">
      La Kreinto severe rigardis al la kunvenintaj anoj: anĝeloj, serafimoj, arkanĝeloj, kaj ankaŭ Lucifero, 
      la ĉefanĝelo kiun, pro gravega pristudota demando, oni oficvojaĝigis el prizorgata de li Infero. 
    <p>
    
    <p class="mb-3">
      -	Nu, kion ni faru pri tiu problemo, kiu okupas unuan lokon en nia hodiaŭa tagordo? 
      Sekretario, bv anonci!
    <p>

    <p class="mb-3">
      La Sekretario, ark. Gabrielo, kiu plenumas kutime diversajn taskojn por la Majstro, laŭte anoncis:
    <p>

    <p class="mb-3">
      -	Tagordo. 
      Punkto unu: pri la sorto de loĝantaro de la Tero, t.n. Homaro. 
      Punkto du: diversaĵoj.
    <p>

    <p class="mb-3">
      Ĉu estas iaj aldonoj al la tagordo de la kunveno? 
    <p>

    <p class="mb-3">
      Aldonoj ne estis. 
    <p>

    <p class="mb-3">
      -	Do, tiam ni eku. 
      La vorton havas Lia Ĉieleco nia Majstro, la Kreinto nia. 
    <p>

    <p class="mb-3">
      (Aplaŭdoj).
    <p>

    <p class="mb-3">
      -	Mi kunvenigis vin ĉi tie por por komuniki al vi tre malagrablan novaĵon: io misas sur nia Tero.
    <p>

    <p class="mb-3">
      Lerta helpanto, anĝeleto de la tria grado, tuj montris sur granda ekrano post la dorso de la preleganto, 
      la kosman mapon de tiu parto de Universo, kie troviĝas tiu Tero, por refreŝigi memoron de tiuj, 
      kiuj jam scias, sed por multaj eĉ konigi la situon de tiu fora kaj neeminenta astro. 
    <p>

    <p class="mb-3">
      -	Vi ĉiuj scias – daŭrigis la Majstro, - ke la aferoj tie ne sekvas la preskribitan planon. 
    <p>

    <p class="mb-3">
      (La plimulto ne sciis, sed obeeme klakis per flugiloj).
    <p>

    <p class="mb-3">
      -	Ni kreis ilin por ke ili nature evoluu, disvolviĝu ekde amebo ĝis la Krono de la Kreaĵo – la Homo! 
      Nu, ĉio bonordis… ĝis la certa punkto. 
      Jes, ĝis Simioj ĉio okazis normale: laŭŝtupa evoluo, pli kaj pli alta organizo, apero de cerbo, 
      du liberaj membroj por labori – kaj fin-fine, la Laboro formis Homon!
    <p>

    <p class="mb-3">
      La kulturita Homo ja estas la celo de nia kreado; atinginte tian nivelon, 
      li jam ne bezonas nian prizorgon kaj mem fariĝas Kreanto. 
      Vi tion bone scias, ĉar multaj el vi iris la saman vojon: el ĉelo al Ĉielo!
    <p>

    <p class="mb-3">
      Sed sur tiu planedeto la evoluo paneis. 
      Atinginte homan aspekton, tieaj Simioj dekomence evoluis rapide kaj forte; sed post ioma tempo la evoluo malrapidiĝis kaj eĉ stagnis. 
      Kaj nun ni vidas unikan okazon en la Universo: la rean evoluon! 
      Homoj denove revenas al Simia stato!
    <p>

    <p class="mb-3">
      Ili ne plu volas labori; kaj sen laboro ili neeviteble degradas. 
      Ili dekomence ne volis, sed jam nun ne povas streĉiĝi, ne povas forte deziri kaj atingi ion; 
      ili perdas siajn artojn: muzikon, pentradon, arkitekturon; ili perdas eĉ lingvon, kiu same kiel laboro, 
      distingas ilin de Simioj. 
      Nun multaj jam ne scipovas skribi kaj legi, kaj interparoli ili preferas per bildetoj, 
      kiel en la aŭroro de Homa civilizacio, kiam ĵus aperis piktografio. 
    <p>

    <p class="mb-3">
      La afero fariĝas danĝera, kaj ni devas kolektive decidi, kion ni faru en tiu situacio. 
      Ja ne devas tiel esti, tio iras kontraŭ ĉiuj naturaj leĝoj… 
      Do, kion ni entreprenu? 
      Mi petas opiniojn de la publiko. 
    <p>

    <p class="mb-3">
      Unua, kompreneble, eksaltis arda Satano: 
    <p>

    <p class="mb-3">
      -	Nu kion priparoli, se klaras ĉio! 
      Ne taŭgas – neniigi! 
      Ne bezonas ni aĉaĵojn en agado nia; nur kompromitas tio nian noblan aferon! 
      Mi povas tuj alporti al ili iun pandemion aŭ nuklean bombon: pfff… - kaj fino!
    <p>

    <p class="mb-3">
      Sed kontestis prudenta Mateo: 
    <p>

    <p class="mb-3">
      -	Ne tiel ni agu, frato! 
      Ne por tio ni bredis zorge civilizaciojn, por ke facilanime neniigi ilin, kiam obstakloj aperas. 
      Ekmemoru, frato, la civilizon sur HPT 3824, kie ili memekstermiĝis – ĉu bone rezultis tio? 
      Kovado, bredado, eluzo de energio, de nutrivaj substancoj – kaj rezulte nenio: eĉ eluzi tiujn restaĵojn de la planedo por iuj utilaj celoj ne eblis. 
      Pura perdo; kaj riproĉo severa al la ĉefo de la eksperimento. 
      Estis li ekzilita ĝuste al vi, frato, al via varmega departamento, kie laborkondiĉoj ne estas komfortaj…
    <p>

    <p class="mb-3">
      Do agu ni ne abrupte, sed sagace, kaj trovu ni kune indan solvon… 
    <p>

    <p class="mb-3">
      Okazis pridiskuto; la voĉoj diversis, kaj la demando estis metita por voĉdonado. 
    <p>

    <p class="mb-3">
      97% de la partoprenantoj voĉdonis por paca, neperforta solvo de la problemo. 
      Ĉar memoris ili la antaŭan fiaskon kaj ĝiajn sekvojn; kaj simple estis ili anĝeloj, arkanĝeloj, do estaĵoj de alta etika nivelo… 
    <p>

    <p class="mb-3">
      Sed konkrete – kion fari? 
      Kiel reale solvi la problemon? 
      Kaj jen iu kerubo, nomata Darvinaelo, proponis originalan solvon:
    <p>

    <p class="mb-3">
      - Returnu ni tie evoluon! 
      Se ili mem ekstaris sur tiun vojon, ni nur helpu al ili. 
      Ni okazigu Rean Evoluon: lasu ilin reveni al ilia antaŭa ŝtupo, la Simioj! 
    <p>

    <p class="mb-3">
      Nenion ekstermi, nenion neniigi: se ili mem tion faros, estos nur ilia ago, ne nia. 
      Ili jam nenion kapablas, mole kaj trankvile ili estingiĝas sen damaĝo al la planedo kaj al ni. 
      Ni nenion ruinigos: ni ne revenigos la evoluon ĝis unuĉeluloj, 
      ne! ni nur iom rapidigos ilian re-evoluon je unu paŝo, nur unu paŝo! 
      Ja sur Simia nivelo ili ja procedis normale! 
      Nur unu paŝeto retroen – kaj ĉio bonordiĝos por ĉiesa ĝojo!
    <p>

    <p class="mb-3">
      La vortoj ŝajnis prudentaj kaj kontentigis ĉiujn. 
      Unuanime estis voĉdonita la decido:
    <p>

    <p class="mb-3">
      - Plirapidigi la rean evoluon sur la planedo Tero, por ke ĝiaj loĝantoj ene de kelkaj generacioj 
      (sekundoj laŭ la Universa tempo) fariĝu denove Simioj, do revenu al la antaŭa stato. 
      Ili definitive perdu ĉiujn artojn, sciencojn, kulturojn; ili scipovu nek legi, nek skribi, 
      nek interkomunikiĝi por fari ion komune; ili ne plu manĝu proteinajn manĝaĵojn, kiuj promocias mensan agadon: 
      ili ĝenerale manĝu nur fruktojn, kiel faris Simioj. 
    <p>

    <p class="mb-3">
      Kaj lasta sed ne balasta – ili denove ekhavos vostojn, kiel ĉiuj mamuloj surtere. 
      Ili ne laboros, kaj do ne bezonos liberajn brakojn; sed la vosto ja povos servi kiel la kvina membro, 
      ĉu ne? Havi voston – kia oportuna afero! Kiel utila ĝi povas esti! 
      Kaj eble, la novaj Homoj konservos ĝin, kaj tio estos nova bela frukto de nova evoluo, 
      kiu trafos tiujn eks-Homojn kaj farus el ili novan belan Homaron, pli perfektan ol la antaŭa?
    <p>

    <p class="mb-3">
      Ho, bela nova mondo! 
      Ni kredas je vi!
    <p>

    <p class="mb-3">
      La decido estis akceptita, kun la aldono, 
      ke oni omaĝu la proponinton de tiu brila ideo per eternigo de lia nomo: la Rea Evoluo laŭ Darvinaelo.
    <p>

    <p class="mb-3">
      La kunveno finita… Kaj sur la planedo Tero tuj komenciĝis la plenumado de la decido, 
      ĉar la Universaj leĝoj funkcias ĉiam kaj ĉie. 
    <p>

    <p class="mb-3">
      Bonvenon, Nova Mondo!
    <p>
    `
  )
}

const itemName = {
  esp: 'Rea evoluo'
}

const date = {
  esp: 'La 25an de junio, 2022'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemAuthor: author.esp,
    itemDate: date.esp
  }
}

export default item; 